import ArbreUniteBis from './ArbreUnite'
import RechercheUnite from './RechercheUnite'
import { Progress } from '../Utils/Progress'
import { useFetchContext } from '../../hook/UseFetchContext'
import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const PREFIX = 'BlocUnite'

const classes = {
  tree: `${PREFIX}-tree`
}

const StyledProgress = styled(Progress)(() => ({
  [`& .${classes.tree}`]: {
    margin: 0,
    padding: 0,
    maxHeight: '70vh',
    minHeight: '55vh',
    flexGrow: 1,
    overflow: 'auto',
    overflowY: 'scroll',
    overflowX: 'hidden'
  }
}))

export default function BlocUnite() {
  const { state } = useFetchContext()
  const noeuds = state.dimensionState.noeuds

  return noeuds.length > 0 ? (
    <div>
      <Typography
        component="h2"
        variant="subtitle1"
        color="secondary"
        sx={{ textAlign: 'center', my: -1 }}
      >
        Recherche d'une unité
      </Typography>
      <RechercheUnite />
      <div className={classes.tree}>
        <ArbreUniteBis />
      </div>
    </div>
  ) : (
    <StyledProgress texte="Chargement des unités en cours..." />
  )
}
